import React, { useContext, useState } from "react";
import ReactDOM from "react-dom";
import { useEffect } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import AuthService from "../../services/auth.service";
import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import moment from "moment";
import { API_URL, API_URL_PAYMENT } from "../../utilities/url";
import { FiEye, FiPlus } from "react-icons/fi";
import { Button } from "react-bootstrap";
import storage from "../../services/storage";
import { FaChartBar, FaClipboardList, FaDollarSign } from "react-icons/fa";
import CryptoJS from "crypto-js";
import axios from "axios";
import { format_number } from "../../utilities/ext-function";
import Skeleton from "react-loading-skeleton";
import ReportChatbotInteraction from "./component/reportChatbotInteraction";
import ReportChatbotMostActiveUsers from "./component/reportChatbotMostActiveUsers";
import ReportSentimentAnalysis from "./component/reportSentimentAnalysis";
import { first } from "lodash";
import authService from "../../services/auth.service";
var $ = require("jquery");

const ReportChatbot = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [dataReport, setDataReport] = useState(null);
  const [dataInteraction, setDataInteraction] = useState([]);
  const [dataMostActiveUsers, setDataMostActiveUsers] = useState([]);
  const [dataHotTopic, setDataHotTopic] = useState([]);
  const [dataSuggestion, setDataSuggestion] = useState([]);
  const [dataUnanswered, setDataUnanswered] = useState([]);
  const [firstTab2, setfirstTab2] = useState(true);
  const [dataTab3, setDataTab3] = useState([]);
  const [open1, setOpen1] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);
  const decryptUSR = CryptoJS.AES.decrypt(storage.get("user"), "user").toString(
    CryptoJS.enc.Utf8
  );
  const usr = JSON.parse(decryptUSR);
  const decryptWS = CryptoJS.AES.decrypt(storage.get("wrs"), "wrs").toString(
    CryptoJS.enc.Utf8
  );
  const workspace = JSON.parse(decryptWS);
  const idChatbot = CryptoJS.AES.decrypt(id.replace(/_/g, "/"), "wrs").toString(
    CryptoJS.enc.Utf8
  );
  const [activeTab, setActiveTab] = useState("interactionStatistic");

  useEffect(() => {
    getData();
  }, [location.key]);

  useEffect(() => {
    if (activeTab === "interactionStatistic") {
      getDataTab1();
    } else if (activeTab === "sentimentAnalysis") {
      if (firstTab2) {
        getDataTab2();
      }
    }
  }, [activeTab, location.key]);

  const getData = () => {
    axios
      .post(
        `${API_URL}get-report-chatbot`,
        { id: idChatbot },
        {
          headers: {
            Authorization: `Bearer ${storage.get("access_token")}`,
          },
        }
      )
      .then((res) => {
        if (res.data.success === true) {
          setDataReport(res.data.data);
        } else {
          navigate("/chatbot");
        }
      })
      .catch((error) => {
        if (error.response.data.message) {
          authService.logout();
        }
      });
  };

  const getDataTab1 = () => {
    axios
      .get(API_URL_PAYMENT + "dashboard/osa/detail", {
        params: {
          osaid: idChatbot,
          lastndays: 30,
        },
        headers: {
          "X-User-ID": usr.idt_user,
          "X-Workspace-ID": workspace.idt_user_workspace,
        },
      })
      .then((response) => {
        if (response.data.errorcode === "0000") {
          setLoading(false);
          setDataInteraction(
            response.data.data.Interactions
              ? response.data.data.Interactions
              : []
          );
          setDataMostActiveUsers(
            response.data.data.MostActiveUsers
              ? response.data.data.MostActiveUsers
              : []
          );
        } else {
          setLoading(false);
          setDataInteraction([]);
          setDataMostActiveUsers([]);
        }
      })
      .catch((error) => {
        if (error.response.data.message) {
          authService.logout();
        }
      });
  };

  const getDataTab2 = () => {
    axios
      .post(
        `${API_URL}get-chatbot-sentiment-analysis`,
        { id: idChatbot },
        {
          headers: {
            Authorization: `Bearer ${storage.get("access_token")}`,
          },
        }
      )
      .then((res) => {
        if (res.data.success === true) {
          if (res.data.data.hot_topic.length > 0) {
            setDataHotTopic(res.data.data.hot_topic);
          }
          if (res.data.data.content_suggestion.length > 0) {
            setDataSuggestion(res.data.data.content_suggestion);
          }
          if (res.data.data.unanswered.length > 0) {
            setDataUnanswered(res.data.data.unanswered);
          }
        }
        setfirstTab2(false);
      })
      .catch((error) => {
        if (error.response.data.message) {
          authService.logout();
        }
      });
  };

  return (
    <div className="container-fluid p-0">
      <div className="row mb-2 mb-xl-3">
        <div className="col-auto">
          <h5>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/chatbot">Chatbot</Link>
                </li>
                <li className="breadcrumb-item active">Report & Analysis</li>
              </ol>
            </nav>
          </h5>
        </div>
      </div>
      <div className="row">
        <div class="card flex-fill rounded-4 shadow-lg">
          <div className="card-header rounded-4">
            <h5 className="card-title text-center">Report & Analysis</h5>
          </div>
          <div class="card-body">
            <div className="row">
              <div className="col-md-8 mb-5">
                <div className="mb-2 row">
                  <p className="text-dark fs-3">
                    {dataReport ? (
                      dataReport.name
                    ) : (
                      <Skeleton width={200} height={28} />
                    )}
                  </p>
                </div>
                <div className="mb-2 row">
                  <label
                    className="col-form-label col-sm-3 text-sm-right"
                    style={{ lineHeight: "1.5" }}
                  >
                    Chatbot Interaction
                  </label>
                  <div className="col-sm-4 error-placeholder">
                    {dataReport ? (
                      <p className="text-dark mt-1">
                        {format_number(dataReport.message_count)}
                      </p>
                    ) : (
                      <Skeleton width={200} height={32} />
                    )}
                  </div>
                </div>
                <div className="mb-2 row">
                  <label
                    className="col-form-label col-sm-3 text-sm-right"
                    style={{ lineHeight: "1.5" }}
                  >
                    Total Unique Contact
                  </label>
                  <div className="col-sm-4 error-placeholder">
                    {dataReport ? (
                      <p className="text-dark mt-1">
                        {format_number(dataReport.unique_contact)}
                      </p>
                    ) : (
                      <Skeleton width={200} height={32} />
                    )}
                  </div>
                </div>
                <div className="mb-2 row">
                  <label
                    className="col-form-label col-sm-3 text-sm-right"
                    style={{ lineHeight: "1.5" }}
                  >
                    Device
                  </label>
                  <div className="col-sm-9 error-placeholder">
                    {dataReport ? (
                      dataReport.device_assigment.length > 0 ? (
                        dataReport.device_assigment.map((item) => (
                          <span
                            key={item.idt_device_assignment}
                            className="badge bg-primary px-2 py-1 me-2"
                          >
                            {item.device.name}
                          </span>
                        ))
                      ) : (
                        <p className="text-dark mt-1">-</p>
                      )
                    ) : (
                      <Skeleton width={200} height={32} />
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                {/* Nav Tabs */}
                <ul className="nav nav-tabs">
                  <li className="nav-item text-center">
                    <a
                      className={`nav-link ${
                        activeTab === "interactionStatistic" ? "active" : ""
                      }`}
                      onClick={() => setActiveTab("interactionStatistic")}
                    >
                      <FaClipboardList className="mt-1 mb-1" size={20} /> <br />{" "}
                      Chatbot Interaction Statistics
                    </a>
                  </li>
                  <li className="nav-item text-center">
                    <a
                      className={`nav-link ${
                        activeTab === "sentimentAnalysis" ? "active" : ""
                      }`}
                      onClick={() => setActiveTab("sentimentAnalysis")}
                    >
                      <FaChartBar className="mt-1 mb-1" size={20} /> <br />{" "}
                      Sentiment Analysis
                    </a>
                  </li>
                  {/* <li className="nav-item text-center">
                    <a
                      className={`nav-link ${
                        activeTab === "monetizationDashboard" ? "active" : ""
                      }`}
                      onClick={() => setActiveTab("monetizationDashboard")}
                    >
                      <FaDollarSign className="mt-1 mb-1" size={20} /> <br />{" "}
                      Monetization Dashboard
                    </a>
                  </li> */}
                </ul>

                {/* Tab Content */}
                <div className="tab-content mt-3">
                  {activeTab === "interactionStatistic" && (
                    <div className="tab-pane fade show active">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="card mb-2 shadow-lg">
                            <div className="card-header pb-0">
                              <div className="card-title fs-14">
                                Filter: Last 30 Days
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-7">
                          <div className="card shadow-lg">
                            <div className="card-header pb-0">
                              <div className="card-title fs-16">
                                Interaction History
                              </div>
                            </div>
                            <div className="card-body">
                              <ReportChatbotInteraction
                                selectedData={dataInteraction}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-5">
                          <div className="card shadow-lg">
                            <div className="card-header pb-0">
                              <div className="card-title fs-16">
                                Most Active Users
                              </div>
                            </div>
                            <div className="card-body">
                              <ReportChatbotMostActiveUsers
                                selectedData={dataMostActiveUsers}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {activeTab === "sentimentAnalysis" && (
                    <div className="tab-pane fade show active">
                      <ReportSentimentAnalysis
                        dataHotTopic={dataHotTopic}
                        setDataHotTopic={setDataHotTopic}
                        dataSuggestion={dataSuggestion}
                        setDataSuggestion={setDataSuggestion}
                        dataUnanswered={dataUnanswered}
                        setDataUnanswered={setDataUnanswered}
                        idChatbot={idChatbot}
                        usr={usr}
                        workspace={workspace}
                        open1={open1}
                        setOpen1={setOpen1}
                        open2={open2}
                        setOpen2={setOpen2}
                        open3={open3}
                        setOpen3={setOpen3}
                      />
                    </div>
                  )}
                  {/* {activeTab === "monetizationDashboard" && (
                    <div className="tab-pane fade show active">
                      💰 Monetization Dashboard Content
                    </div>
                  )} */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportChatbot;
